import { useContactNotificationsStore } from '../store/contact-notifications.store';

export interface UseContactNotificationsReturn {
  totalNuevos: number;
  totalMensajes: number;
  refreshStats: () => Promise<void>;
}

export const useContactNotifications = (): UseContactNotificationsReturn => {
  const totalNuevos = useContactNotificationsStore((state) => state.totalNuevos);
  const totalMensajes = useContactNotificationsStore((state) => state.totalMensajes);
  const refreshStats = useContactNotificationsStore((state) => state.refreshStats);

  return {
    totalNuevos,
    totalMensajes,
    refreshStats,
  };
};
